import { Card } from "antd";

export default function PageStudentDashboard() {
    return <Card>PAGESTUDENTDASHBOARD IS UNDER CONSTRUCTION</Card>;
}
